<app-header (selectedLang)="getLanguage($event)"></app-header>

<div class="mis_view">
  <div class="row">

    <spinner [id]="'misfilter'" [show]='activeSpinner'></spinner>
    <div class="col-md-12">
      <div class="tab form-group mb-5" role="tabpanel">
        <ul class="nav nav-tabs" role="tablist">
          <li role="presentation" class="nav-item pointer"><a class="nav-link"
              [ngClass]="{'active': activesidetab == 'smartchart'}" (click)="navtabclick('smartchart')"
              name="smartchartview" aria-selected="false">{{'misviewtabs.smartview' | translate}}</a></li>
          <!-- <li *ngIf =  "userdetails && (userdetails['roles'][0] == 'VALIDATION_AGENCY' || userdetails['roles'][0] == 'ADMIN' )"role="presentation" class="nav-item pointer"><a class="nav-link"
                [ngClass]="{'active': activesidetab == 'indicatorstatus'}" (click)="navtabclick('indicatorstatus')"
                name="indicatorstatus" aria-selected="false">Indicator Status</a></li> -->
          <li role="presentation" class="nav-item pointer"><a class="nav-link"
              [ngClass]="{'active': activesidetab == 'comparison'}" (click)="navtabclick('comparison')"
              name="comparisonview" aria-selected="false">{{'misviewtabs.comparisonview' | translate}}</a></li>
          <li role="presentation" class="nav-item pointer"><a class="nav-link"
              [ngClass]="{'active': activesidetab == 'customranking'}" (click)="navtabclick('customranking')"
              name="customrankingview" aria-selected="false">{{'misviewtabs.customranking' | translate}}</a></li>
          <li role="presentation" class="nav-item pointer"><a class="nav-link"
              [ngClass]="{'active': activesidetab == 'indicatorchart'}" (click)="navtabclick('indicatorchart')"
              name="indicatorwisecomparison" aria-selected="false">{{'misviewtabs.indcomp' | translate}}</a></li>
          <li role="presentation" class="nav-item pointer"><a class="nav-link"
              [ngClass]="{'active': activesidetab == 'themechart'}" (click)="navtabclick('themechart')"
              name="themewisecomparison" aria-selected="false">{{'misviewtabs.themewise' | translate}}</a></li>
          <!-- <li role="presentation" class="nav-item pointer"><a class="nav-link"
              [ngClass]="{'active': activesidetab == 'reportDownload'}" (click)="navtabclick('reportDownload')"
              name="reportDownload" aria-selected="false">Reports</a></li> -->

        </ul>

        <div class="tab-content" *ngIf="activesidetab != 'reportDownload'">
          <div role="tabpanel" class="tab-pane fade active show" id="pending">
            <app-misfilter [selectedlanguage]="lang" *ngIf="activesidetab != 'reportDownload'"
              (datasubmitted)="changeLabel($event)" (slectedmonth)="changeMonth($event)"
              (emptyngModel)="emptyMonth($event)" (baseselecteddistrict)="basedistrict($event)"
              (baseselectedstate)="baseState($event)" (selectedId)="changeUUID($event)"
              (selecteddistId)="changeDistuuid($event)" (eventEmitter)="handleEventFromFilter($event)"
              (distName)="getDistrictName($event)" [activeTab]="activesidetab" ></app-misfilter>
            <!-- <div class="d-flex flex-row-reverse" *ngIf="activesidetab == 'customranking'"></div> -->

            <div *ngIf="activesidetab == 'customranking' && statelist.length > 0" class="col-auto ">
              <button class="btn btn-info pull-right pointer" name="download" (click)="exportToExcel()"><i
                  class="fa fa-download"></i></button>
            </div>
            <div *ngIf="activesidetab == 'indicatorstatus' && stateLevel == true" class="col-auto">
              <button class="btn btn-info pull-right pointer" name="download" (click)="indicatorExcelData()"><i
                  class="fa fa-download"></i>
              </button>
            </div>
            <div *ngIf="activesidetab == 'indicatorstatus' && stateLevel == false" class="col-auto">
              <button class="btn btn-info pull-right pointer" name="download" (click)="indicatorDistrictsData()"><i
                  class="fa fa-download"></i>
              </button>
            </div>

            <!-- <div class="d-flex flex-row-reverse" *ngIf="activesidetab == 'comparison'"></div> -->

            <div *ngIf="activesidetab == 'comparison'" class="col-auto d-flex justify-content-end align-items-end mt-2">
              <button class="btn btn-info pull-right pointer" name="download" (click)="downloadExcel()"><i
                  class="fa fa-download"></i>
              </button>
            </div>

            <!-- <div class="col-md-1" *ngIf="activesidetab == 'comparison'" style="position: absolute; right: -57px; top: 100px;">
              <button class="btn btn-info pull-right pointer" name="download" (click)="downloadExcel()"><i
                  class="fa fa-download"></i></button>
            </div> -->
            <div class="card mb-2"
              *ngIf="activesidetab == 'indicatorstatus' && userdetails && (userdetails['roles'][0] == 'VALIDATION_AGENCY' || userdetails['roles'][0] == 'ADMIN'  )">

              <div class="row">
                <div class="col-12 col-lg-12">
                  <div class="table-responsive" id="tableId">
                    <table class="table table-sm table-striped m-0">
                      <thead class="bg-primary text-white">
                        <tr>
                          <th scope="col" style="text-align: center;">S.No</th>
                          <th scope="col" style="text-align: center;" *ngIf="stateLevel == true">States</th>
                          <th scope="col" style="text-align: center;" *ngIf="stateLevel == false">States</th>
                          <th scope="col" style="text-align: center;" *ngIf="stateLevel == false">Districts</th>
                          <th scope="col" style="text-align: center;">Total Mandatory Indicators</th>
                          <th scope="col" style="text-align: center;" *ngIf="stateLevel == true">Number of Indicators
                            with Data Submission Completed @SNO Level</th>
                          <th scope="col" style="text-align: center;" *ngIf="stateLevel == false">Number of Indicators
                            with Data Submission Completed @DNO Level</th>
                          <th scope="col" style="text-align: center;" *ngIf="stateLevel == false">Number of Indicators
                            with Data Submission Completed @SNO Level</th>
                          <th scope="col" style="text-align: center;" *ngIf="stateLevel == true">Validation Agency
                            Approval Pending</th>
                          <th scope="col" style="text-align: center;" *ngIf="stateLevel == false">Validation Agency
                            Approval Pending</th>
                        </tr>
                      </thead>
                      <tbody>
                        <ng-container>
                          <tr *ngFor="let tableData of dropdownlist  let i=index">
                            <td>{{i+1}}</td>
                            <td *ngIf="stateLevel == false">{{stateSpecified}}</td>
                            <td style="cursor: pointer"
                              (click)="stateLevel == true && onClick(tableData['name'],tableData['lu'])">
                              {{tableData.name}}</td>
                            <td *ngIf="stateLevel == true" style="text-align: center">
                              {{tableData.total_mondatary_indicators}}</td>
                            <td *ngIf="stateLevel == false" style="text-align: center">
                              {{tableData.total_mondatary_indicators}}</td>
                            <td *ngIf="stateLevel == true" style="text-align: center">{{tableData.sno_completed}}</td>
                            <td *ngIf="stateLevel == false" style="text-align: center">{{tableData.dno_completed}}</td>
                            <td *ngIf="stateLevel == false" style="text-align: center">{{tableData.sno_completed}}</td>
                            <td *ngIf="stateLevel == true || stateLevel == false" style="text-align: center">
                              {{tableData.iva_pending}}</td>
                          </tr>
                        </ng-container>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div class="card mb-2" *ngIf="activesidetab == 'smartchart'">
              <div id="carouselExampleControls" class="carousel slide" data-ride="carousel">

                <div *ngIf="group_array.length==1">
                  <div class="carousel-inner" role="listbox">

                    <div class="container-fluid p-0" *ngIf='tab==0'>
                      <div class="row">
                        <div class="col-12 col-lg-12">
                          <div class="card-header">
                            <h3>{{'infotab.datatitle' | translate}}</h3>
                            <h5>{{'misviewtabs.rankingsect' | translate}}({{curyear}})</h5>
                          </div>
                          <div class="card-body">
                            <div
                              *ngIf="stateitemList.includes('BIHAR') && biharchartData && biharchartData['seriesdata'][0]['data'].length > 0">
                              <!-- <app-bar-chart [chartData]="biharchartData" [chartId]="'barChart'"
                                [yAxisPlot]="biharstateArray">
                              </app-bar-chart> -->
                              <app-bar-bubble-chart [barchartData]="biharchartData" [chartId]="'BiharChart'"
                                [yAxisPlot]="biharstateArray" [selectedlanguage]="lang">
                              </app-bar-bubble-chart>
                            </div>
                            <div
                              *ngIf="stateitemList.includes('BIHAR') && biharchartData && biharchartData['seriesdata'][0]['data'].length == 0"
                              class="col-12 nodata text-danger mt-5 mb-5">{{'infotab.nodata' | translate}}</div>
                            <div *ngIf="stateitemList.includes('JHARKHAND')">
                              <div *ngIf="jkchartdata && jkchartdata['seriesdata'][0]['data'].length > 0">
                                <app-bar-bubble-chart [selectedlanguage]="lang" [barchartData]="jkchartdata"
                                  [chartId]="'jharkandFYchart'" [yAxisPlot]="jharkandstateArray">
                                </app-bar-bubble-chart>
                              </div>
                            </div>
                            <div
                              *ngIf="stateitemList.includes('JHARKHAND') && jkchartdata && jkchartdata['seriesdata'][0]['data'].length == 0"
                              class="col-12 nodata text-danger mt-5 mb-5">{{'infotab.nodata' | translate}}</div>
                            <div *ngIf="stateitemList.includes('UTTAR PRADESH')">
                              <div *ngIf="UPchartdata">
                                <app-bar-bubble-chart [selectedlanguage]="lang" [barchartData]="UPchartdata"
                                  [chartId]="'UPstateArrayFYchart'" [yAxisPlot]="UPstateArray">
                                </app-bar-bubble-chart>
                                <!-- <app-bar-chart [chartData]="UPchartdata"
                                  [chartId]="'barChart'" [yAxisPlot]="UPstateArray">
                                </app-bar-chart> -->
                              </div>
                            </div>
                            <div
                              *ngIf="stateitemList.includes('UTTAR PRADESH') && UPchartdata && UPchartdata['seriesdata'][0]['data'].length == 0"
                              class="col-12 nodata text-danger mt-5 mb-5">{{'infotab.nodata' | translate}}</div>
                            <div
                              *ngIf="stateitemList.includes('UTTARAKHAND') && UKchartdata && UKchartdata['seriesdata'][0]['data'].length > 0">
                              <div *ngIf="UKchartdata">
                                <app-bar-bubble-chart [selectedlanguage]="lang" [barchartData]="UKchartdata"
                                  [chartId]="'UKstateArrayFYchart'" [yAxisPlot]="UKstateArray">
                                </app-bar-bubble-chart>
                              </div>
                            </div>
                            <div
                              *ngIf="stateitemList.includes('UTTARAKHAND') && UKchartdata && UKchartdata['seriesdata'][0]['data'].length == 0"
                              class="col-12 nodata text-danger mt-5 mb-5">{{'infotab.nodata' | translate}}</div>
                            <div
                              *ngIf="stateitemList.includes('WEST BENGAL') && WBchartdata && WBchartdata['seriesdata'][0]['data'].length > 0">
                              <div *ngIf="WBchartdata">
                                <app-bar-bubble-chart [selectedlanguage]="lang" [barchartData]="WBchartdata"
                                  [chartId]="'WBstateArrayFYchart'" [yAxisPlot]="WBstateArray">
                                </app-bar-bubble-chart>
                              </div>
                              <div
                                *ngIf="stateitemList.includes('WEST BENGAL') && WBchartdata && WBchartdata['seriesdata'][0]['data'].length == 0"
                                class="col-12 nodata text-danger mt-5 mb-5">{{'infotab.nodata' | translate}}</div>
                            </div>
                          </div>
                        </div>
                      </div>




                    </div>
                  </div>

                  <div class="carousel-inner" role="listbox">
                    <div class="container-fluid" *ngIf='tab==1'>
                      <div class="row">
                        <div class="col-12 lg-12">
                          <div *ngIf="stateitemList.includes('BIHAR')">
                            <div *ngIf="locationBiharData">
                              <app-bar-bubble-chart [selectedlanguage]="lang" [barchartData]="locationBiharData" [chartId]="'barChart'"
                                [yAxisPlot]="locationBiharStateArray">
                              </app-bar-bubble-chart>
                            </div>

                          </div>
                          <div *ngIf="stateitemList.includes('JHARKHAND')">
                            <div *ngIf="locationJKData">
                              <app-bar-bubble-chart [selectedlanguage]="lang" [barchartData]="locationJKData" [chartId]="'jharkandFYchart'"
                                [yAxisPlot]="locationJKStateArray">
                              </app-bar-bubble-chart>
                            </div>

                          </div>
                          <div *ngIf="stateitemList.includes('UTTAR PRADESH')">
                            <div *ngIf="locationUPData">
                              <app-bar-bubble-chart [selectedlanguage]="lang" [barchartData]="locationUPData" [chartId]="'UPstateArrayFYchart'"
                                [yAxisPlot]="locationUPStateArray"></app-bar-bubble-chart>
                            </div>

                          </div>
                          <div *ngIf="stateitemList.includes('UTTARAKHAND')">
                            <div *ngIf="locationUKData">
                              <app-bar-bubble-chart  [selectedlanguage]="lang" [barchartData]="locationUKData" [chartId]="'UKstateArrayFYchart'"
                                [yAxisPlot]="locationUKtateArray"></app-bar-bubble-chart>
                            </div>

                          </div>
                          <div *ngIf="stateitemList.includes('WEST BENGAL')">
                            <div *ngIf="locationWBData">
                              <app-bar-bubble-chart [selectedlanguage]="lang" [barchartData]="locationWBData" [chartId]="'WBstateArrayFYchart'"
                                [yAxisPlot]="locationWBStateArray"></app-bar-bubble-chart>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div *ngIf="group_array.length==2">
                  <div class="carousel-inner" role="listbox">
                    <div class="container" *ngIf='tab==0'>
                      <h3>{{'infotab.datatitle' | translate}}</h3>
                      <h5>{{'misviewtabs.rankingsect' | translate}}({{curyear}})</h5>
                      <hr>

                      <div class="row" *ngIf="stateitemList.includes('BIHAR') && stateitemList.includes('JHARKHAND')">

                        <div class="col-md-6">
                          <div *ngIf="biharchartData">
                            <app-bar-chart [chartData]="biharchartData" [chartId]="'barChart'"
                              [yAxisPlot]="biharstateArray"></app-bar-chart>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div *ngIf="jkchartdata">
                            <app-bar-chart [chartData]="jkchartdata" [chartId]="'jharkandFYchart'"
                              [yAxisPlot]="jharkandstateArray"></app-bar-chart>
                          </div>
                        </div>

                      </div>

                      <div class="row"
                        *ngIf="stateitemList.includes('JHARKHAND') && stateitemList.includes('UTTAR PRADESH')">

                        <div class="col-md-6">
                          <div *ngIf="jkchartdata">
                            <app-bar-chart [chartData]="jkchartdata" [chartId]="'jharkandFYchart'"
                              [yAxisPlot]="jharkandstateArray"></app-bar-chart>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div *ngIf="UPchartdata">
                            <app-bar-chart [chartData]="UPchartdata" [chartId]="'UPstateArrayFYchart'"
                              [yAxisPlot]="UPstateArray"></app-bar-chart>
                          </div>
                        </div>

                      </div>

                      <div class="row"
                        *ngIf="stateitemList.includes('UTTAR PRADESH') && stateitemList.includes('UTTARAKHAND')">

                        <div class="col-md-6">
                          <div *ngIf="UPchartdata">
                            <app-bar-chart [chartData]="UPchartdata" [chartId]="'UPstateArrayFYchart'"
                              [yAxisPlot]="UPstateArray"></app-bar-chart>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div *ngIf="UKchartdata">
                            <app-bar-chart [chartData]="UKchartdata" [chartId]="'UKstateArrayFYchart'"
                              [yAxisPlot]="UKstateArray"></app-bar-chart>
                          </div>
                        </div>
                      </div>
                      <div class="row"
                        *ngIf="stateitemList.includes('UTTARAKHAND') && stateitemList.includes('WEST BENGAL')">

                        <div class="col-md-6">
                          <div *ngIf="UKchartdata">
                            <app-bar-chart [chartData]="UKchartdata" [chartId]="'UKstateArrayFYchart'"
                              [yAxisPlot]="UKstateArray"></app-bar-chart>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div *ngIf="WBchartdata">
                            <app-bar-chart [chartData]="WBchartdata" [chartId]="'WBstateArrayFYchart'"
                              [yAxisPlot]="WBstateArray"></app-bar-chart>
                          </div>
                        </div>
                      </div>
                      <div class="row" *ngIf="stateitemList.includes('WEST BENGAL') && stateitemList.includes('BIHAR')">

                        <div class="col-md-6">
                          <div *ngIf="WBchartdata">
                            <app-bar-chart [chartData]="WBchartdata" [chartId]="'WBstateArrayFYchart'"
                              [yAxisPlot]="WBstateArray"></app-bar-chart>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div *ngIf="biharchartData">
                            <app-bar-chart [chartData]="biharchartData" [chartId]="'barChart'"
                              [yAxisPlot]="biharstateArray"></app-bar-chart>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>

                  <div *ngIf="stateitemList.includes('BIHAR') && stateitemList.includes('JHARKHAND')">
                    <div class="carousel-inner" role="listbox">
                      <div class="container-fluid" *ngIf='tab==1'>
                        <div class="row">
                          <div class="col-12 col-lg-12">
                            <div *ngIf="locationBiharData">
                              <app-bar-bubble-chart [selectedlanguage]="lang" [barchartData]="locationBiharData" [chartId]="'barChart'"
                                [yAxisPlot]="locationBiharStateArray">
                              </app-bar-bubble-chart>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>

                    <div class="carousel-inner" role="listbox">
                      <div class="container-fluid" *ngIf='tab==2'>
                        <div class="row">
                          <div class="col-12 col-lg-12">
                            <div *ngIf="locationJKData">
                              <app-bar-bubble-chart [selectedlanguage]="lang" [barchartData]="locationJKData" [chartId]="'jharkandFYchart'"
                                [yAxisPlot]="locationJKStateArray"></app-bar-bubble-chart>
                            </div>
                          </div>
                        </div>



                      </div>
                    </div>
                  </div>

                  <div *ngIf="stateitemList.includes('JHARKHAND') && stateitemList.includes('UTTAR PRADESH')">
                    <div class="carousel-inner" role="listbox">
                      <div class="container-fluid" *ngIf='tab==1'>
                        <div class="row">
                          <div class="col-12 col-lg-12">
                            <div *ngIf="locationJKData">
                              <app-bar-bubble-chart [selectedlanguage]="lang" [barchartData]="locationJKData" [chartId]="'jharkandFYchart'"
                                [yAxisPlot]="locationJKStateArray"></app-bar-bubble-chart>
                            </div>
                          </div>
                        </div>



                      </div>
                    </div>

                    <div class="carousel-inner" role="listbox">
                      <div class="container-fluid" *ngIf='tab==2'>
                        <div class="row">
                          <div class="col-12 col-lg-12">
                            <div *ngIf="locationUPData">
                              <app-bar-bubble-chart [selectedlanguage]="lang" [barchartData]="locationUPData" [chartId]="'UPstateArrayFYchart'"
                                [yAxisPlot]="locationUPStateArray"></app-bar-bubble-chart>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div *ngIf="stateitemList.includes('UTTAR PRADESH') && stateitemList.includes('UTTARAKHAND')">
                    <div class="carousel-inner" role="listbox">
                      <div class="container container-fluid" *ngIf='tab==1'>
                        <div class="row">
                          <div class="col-12 col-lg-12">
                            <div *ngIf="locationUPData">
                              <app-bar-bubble-chart [selectedlanguage]="lang" [barchartData]="locationUPData" [chartId]="'UPstateArrayFYchart'"
                                [yAxisPlot]="locationUPStateArray"></app-bar-bubble-chart>
                            </div>
                          </div>
                        </div>



                      </div>
                    </div>

                    <div class="carousel-inner" role="listbox">
                      <div class="container-fluid" *ngIf='tab==2'>

                        <div class="row">
                          <div class="col-12 col-lg-12">
                            <div *ngIf="locationUKData">
                              <app-bar-bubble-chart [selectedlanguage]="lang" [barchartData]="locationUKData" [chartId]="'UKstateArrayFYchart'"
                                [yAxisPlot]="locationUKtateArray"></app-bar-bubble-chart>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                  <div *ngIf="stateitemList.includes('UTTARAKHAND') && stateitemList.includes('WEST BENGAL')">
                    <div class="carousel-inner" role="listbox">
                      <div class="container container-fluid" *ngIf='tab==1'>
                        <div class="row">
                          <div class="col-12 col-lg-12">
                            <div *ngIf="locationUKData">
                              <app-bar-bubble-chart [selectedlanguage]="lang" [barchartData]="locationUKData" [chartId]="'UKstateArrayFYchart'"
                                [yAxisPlot]="locationUKtateArray"></app-bar-bubble-chart>
                            </div>
                          </div>
                        </div>



                      </div>
                    </div>

                    <div class="carousel-inner" role="listbox">
                      <div class="container-fluid" *ngIf='tab==2'>

                        <div class="row">
                          <div class="col-12 col-lg-12">
                            <div *ngIf="locationWBData">
                              <app-bar-bubble-chart [selectedlanguage]="lang" [barchartData]="locationWBData" [chartId]="'WBstateArrayFYchart'"
                                [yAxisPlot]="locationWBtateArray"></app-bar-bubble-chart>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                  <div *ngIf="stateitemList.includes('WEST BENGAL') && stateitemList.includes('BIHAR')">
                    <div class="carousel-inner" role="listbox">
                      <div class="container container-fluid" *ngIf='tab==1'>
                        <div class="row">
                          <div class="col-12 col-lg-12">
                            <div *ngIf="locationWBData">
                              <app-bar-bubble-chart [selectedlanguage]="lang" [barchartData]="locationWBData" [chartId]="'WBstateArrayFYchart'"
                                [yAxisPlot]="locationWBtateArray"></app-bar-bubble-chart>
                            </div>
                          </div>
                        </div>



                      </div>
                    </div>

                    <div class="carousel-inner" role="listbox">
                      <div class="container-fluid" *ngIf='tab==2'>

                        <div class="row">
                          <div class="col-12 col-lg-12">
                            <div *ngIf="locationBiharData">
                              <app-bar-bubble-chart [selectedlanguage]="lang" [barchartData]="locationBiharData" [chartId]="'barChart'"
                                [yAxisPlot]="locationBiharStateArray">
                              </app-bar-bubble-chart>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>

                <div *ngIf="group_array.length==3">
                  <div class="carousel-inner" role="listbox">
                    <div class="container" *ngIf='tab==0'>
                      <h3>{{'infotab.datatitle' | translate}}</h3>
                      <h5>{{'misviewtabs.rankingsect' | translate}}({{curyear}})</h5>
                      <hr>
                      <div class="row">

                        <div class="col-md-4" *ngIf="stateitemList.includes('BIHAR')">
                          <div *ngIf="biharchartData">
                            <app-bar-chart [chartData]="biharchartData" [chartId]="'barChart'"
                              [yAxisPlot]="biharstateArray"></app-bar-chart>
                          </div>
                        </div>

                        <div class="col-md-4" *ngIf="group_array.includes('JHARKHAND')">
                          <div *ngIf="jkchartdata">
                            <app-bar-chart [chartData]="jkchartdata" [chartId]="'jharkandFYchart'"
                              [yAxisPlot]="jharkandstateArray"></app-bar-chart>
                          </div>

                        </div>

                        <div class="col-md-4" *ngIf="group_array.includes('UTTAR PRADESH')">
                          <div *ngIf="UPchartdata">
                            <app-bar-chart [chartData]="UPchartdata" [chartId]="'UPstateArrayFYchart'"
                              [yAxisPlot]="UPstateArray"></app-bar-chart>
                          </div>
                        </div>
                        <div class="col-md-4" *ngIf="group_array.includes('UTTARAKHAND')">
                          <div *ngIf="UKchartdata">
                            <app-bar-chart [chartData]="UKchartdata" [chartId]="'UKstateArrayFYchart'"
                              [yAxisPlot]="UKstateArray"></app-bar-chart>
                          </div>
                        </div>
                        <div class="col-md-4" *ngIf="group_array.includes('WEST BENGAL')">
                          <div *ngIf="WBchartdata">
                            <app-bar-chart [chartData]="WBchartdata" [chartId]="'WBstateArrayFYchart'"
                              [yAxisPlot]="WBstateArray"></app-bar-chart>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>

                  <div class="carousel-inner" role="listbox">
                    <div class="container-fluid" *ngIf='tab==1'>
                      <div class="row">
                        <div class="col-12 col-lg-12">
                          <div *ngIf="stateitemList.includes('BIHAR')">

                            <div *ngIf="locationBiharData">
                              <app-bar-bubble-chart [selectedlanguage]="lang" [barchartData]="locationBiharData" [chartId]="'locationBiharFYData'"
                                [yAxisPlot]="locationBiharStateArray">
                              </app-bar-bubble-chart>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="carousel-inner" role="listbox">
                    <div class="container-fluid" *ngIf='tab==2'>
                      <div class="row">
                        <div class="col-12 col-lg-12">
                          <div *ngIf="group_array.includes('JHARKHAND')">

                            <div *ngIf="locationJKData">
                              <app-bar-bubble-chart [selectedlanguage]="lang" [barchartData]="locationJKData" [chartId]="'jharkandFYchart'"
                                [yAxisPlot]="locationJKStateArray"></app-bar-bubble-chart>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="carousel-inner" role="listbox">
                    <div class="container-fluid" *ngIf='tab==3'>
                      <div class="row">
                        <div class="col-12 col-lg-12">
                          <div *ngIf="stateitemList.includes('UTTAR PRADESH')">

                            <div *ngIf="locationUPData">
                              <app-bar-bubble-chart [selectedlanguage]="lang" [barchartData]="locationUPData" [chartId]="'UPstateArrayFYchart'"
                                [yAxisPlot]="locationUPStateArray"></app-bar-bubble-chart>
                            </div>

                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12 col-lg-12">
                          <div *ngIf="stateitemList.includes('UTTARAKHAND')">

                            <div *ngIf="locationUKData">
                              <app-bar-bubble-chart [selectedlanguage]="lang" [barchartData]="locationUKData" [chartId]="'UKstateArrayFYchart'"
                                [yAxisPlot]="locationUKStateArray"></app-bar-bubble-chart>
                            </div>

                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12 col-lg-12">
                          <div *ngIf="stateitemList.includes('WEST BENGAL')">

                            <div *ngIf="locationWBData">
                              <app-bar-bubble-chart [barchartData]="locationWBData" [chartId]="'WBstateArrayFYchart'"
                                [yAxisPlot]="locationWBStateArray"></app-bar-bubble-chart>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <a *ngIf="stateitemList.includes('BIHAR') && biharchartData && biharchartData['seriesdata'][0]['data'].length > 0"
                  [ngClass]="{'greyout-carousel': this.tab == 0}" class="carousel-control-prev"
                  href="#carouselExampleControls" data-slide="prev" title="Previous Slide">
                  <i class="fas fa-chevron-left slider-arrows" (click)='getPrev()'></i>
                  <!-- <span class="carousel-control-prev-icon" ></span> -->
                </a>
                <a *ngIf="stateitemList.includes('BIHAR') && biharchartData && biharchartData['seriesdata'][0]['data'].length > 0"
                  [ngClass]="{'greyout-carousel': this.tab == 1}" class="carousel-control-next"
                  href="#carouselExampleControls" data-slide="next" title="Next Slide">
                  <i class="fas fa-chevron-right slider-arrows" (click)='getNext()'></i>
                  <!-- <span class="carousel-control-next-icon" (click)='getNext()'></span> -->
                </a>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card mb-2" style="width: -webkit-fill-available;" *ngIf="activesidetab == 'comparison'">

      <div class="row">
        <div class="col-12 col-lg-12">
          <div id="tableId" class="table-responsive p-2">
            <table class="table m-0">
              <thead class="bg-primary text-white">
                <tr>
                  <th scope="col" style="text-align: center;">{{'infotab.district' | translate}}</th>
                  <th scope="col" style="text-align: center;">{{'infotab.gdpmsscore' | translate}}</th>
                  <th scope="col" style="text-align: center;">{{'infotab.gdpmsrank' | translate}}</th>
                  <th scope="col" style="text-align: center;">{{'infotab.compared' | translate}}</th>
                  <th scope="col" style="text-align: center;">{{'infotab.gdpmsbasescore' | translate}}</th>
                  <th scope="col" style="text-align: center;width: 200px;">{{'infotab.gdpmsbasedist' | translate}}</th>
                </tr>
              </thead>
              <tbody>
                <ng-container>
                  <tr *ngFor="let item of tabledataobject">
                    <td>{{item.en ? item.en : '-'}}</td>
                    <td>{{item.currentValue ? validateTableObject(item.currentValue) : '-'}}</td>
                    <td>{{item.currentRank ? item.currentRank : '-'}}</td>
                    <td>{{item.compareden ? item.compareden : '-' }}</td>
                    <td>{{item.baseValue ? validateTableObject(item.baseValue) : '-' }}</td>
                    <td>{{item.baseRank ? item.baseRank : '-' }}</td>
                    <!-- <td
                              [style.background-color]="tabledata['currentValue'] > 65 ? '#90ED7D' : '#FFE481' && tabledata['currentValue']<50 ? '#f56161' : '#FFE481'" style="text-align: center;width: 200px;">
                              {{tabledata['en']}}</td>
                            <td
                              [style.background-color]="tabledata['currentValue'] > 65 ? '#90ED7D' : '#FFE481' && tabledata['currentValue']<50 ? '#f56161' : '#FFE481'" style="text-align: center;width: 200px;">
                              {{tabledata['baseValue'] ? (tabledata['baseValue']).toFixed(2): '-'}}</td>
                            <td
                              [style.background-color]="tabledata['currentValue'] > 65 ? '#90ED7D' : '#FFE481' && tabledata['currentValue']<50 ? '#f56161' : '#FFE481'" style="text-align: center;width: 200px;">
                              {{tabledata['currentValue'] ? (tabledata['currentValue']).toFixed(2)  : '-'}}</td>
                            <td
                              [style.background-color]="tabledata['currentValue'] > 65 ? '#90ED7D' : '#FFE481' && tabledata['currentValue']<50 ? '#f56161' : '#FFE481'" style="text-align: center;width: 200px;">
                              {{tabledata['baseRank'] ? tabledata['baseRank'] : '-'}}</td>
                            <td
                              [style.background-color]="tabledata['currentValue'] > 65 ? '#90ED7D' : '#FFE481' && tabledata['currentValue']<50 ? '#f56161' : '#FFE481'" style="text-align: center;width: 200px;">
                              {{tabledata['currentRank'] ? tabledata['currentRank'] : '-'}}</td>
                            <td
                            style="text-align: center;width: 200px;" [style.background-color]="tabledata['currentValue'] > 65 ? '#90ED7D' : '#FFE481' && tabledata['currentValue']<50 ? '#f56161' : '#FFE481'" style="text-align: center;">
                              <span *ngIf="tabledata['delta']!=null">
                                <i *ngIf="tabledata['delta']>0" class="fa fa-arrow-up font-italic"> Up</i>
                                <i *ngIf="tabledata['delta']<0" class="fa fa-arrow-down font-italic"> Down</i>
                              </span>
                              {{tabledata['delta'] ? makeValuepositive(tabledata['delta']) : '-'}}
                            </td> -->
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
          <div class="row" *ngIf="tabledataobject.length == 0">
            <div class="col-12 nodata text-danger mt-5 mb-5">
              {{'infotab.nodata' | translate}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card mb-2" style="width: -webkit-fill-available;"
      *ngIf="activesidetab == 'customranking' && statelist.length > 0">
      <div class="row">
        <div class="col-12">
          <div class="table-responsive" id="customId">
            <table class="table table-sm table-striped m-0">
              <thead class="bg-primary text-white">
                <tr>
                  <th scope="col" rowspan="2" style="text-align: center;">{{ 'dataSubs.sno' | translate}}</th>
                  <th scope="col" rowspan="2" style="text-align: center;">{{ 'dataSubs.indicator' | translate}}</th>
                  <th scope="col" colspan="2" *ngFor="let state of statelist" class="text-center"
                    style="text-align: center;">
                    {{'districtsdata.' +state['name'] | translate}}</th>
                  <!-- <th scope="col" colspan="2" *ngFor="let state of statelist" class="text-center"
                            style="text-align: center;">
                            {{state['naam']}}</th> -->
                </tr>
                <tr>
                  <th *ngFor="let name of rankactual" colspan="1" style="text-align: center;">
                    {{'setDropDown.'+name | translate}}</th>
                  <!-- <th colspan="1" style="text-align: center;">{{'setDropDown.Rank' | translate}}</th>
                          <th colspan="1" style="text-align: center;">{{'setDropDown.ActualValue' | translate}}</th> -->
                </tr>
              </thead>
              <tbody *ngIf="customTableData.length > 0">
                <ng-container>
                  <tr *ngFor="let item of customTableData">
                    <td style="text-align: center;" *ngFor="let list of item | keys">
                      <span *ngIf="list == 'sno'">{{item[list]}}</span>
                      <span *ngIf="list == 'label'" data-toggle="tooltip" title="{{item[list]}}"
                        data-placement="bottom">{{'indicatorlist.' +item[list] | translate}}<span
                          *ngIf="item[list].length > 4">...</span></span>
                      <!-- <span *ngIf="list == 'hindilabel'" data-toggle="tooltip" title="{{item[list]}}"
                                data-placement="bottom">{{item[list]}}</span> -->

                      <span
                        *ngIf="list != 'sno' && list != 'label' && list!='hindilabel'">{{checkvalue(item[list],list)}}</span>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
          <div class="row" *ngIf="!showcustomtable">
            <div class="col-12 nodata text-danger" style="margin-top: 150px;">
              {{'infotab.nodata' | translate}}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card mb-2" *ngIf="activesidetab == 'indicatorchart' && showindicatordata">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 col-lg-12" *ngIf="!showmap && indicatordata['seriesdata'][0]['data'].length > 0">
            <app-stacked-bar-chart [chartData]="indicatordata" [chartId]="'indicatorChart'" [selectedDistrict]="selectedDistName"
              [yAxisPlot]="indicatorArray"></app-stacked-bar-chart>
          </div>
          <div *ngIf="!showmap && indicatordata['seriesdata'][0]['data'].length == 0"
            class="col-12 nodata text-danger mt-5 mb-5">{{'infotab.nodata' | translate}}</div>
        </div>
        <div class="row" style="display: inherit;">
          <div id="indicatormap" *ngIf="showmap">
          </div>
        </div>
      </div>

    </div>

    <div class="d-flex justify-content-center w-100" *ngIf="activesidetab == 'themechart'">
      <div class="card mb-2 " >

        <div class="container-fluid">
          <div class="row">
            <div class="col-12 col-lg-12" *ngIf="showthemedata">
              <app-bubble-chart [selectedlanguage]="lang" [selectedDistrict]="selectedDistName" [chartData]="themedata" [chartId]="'themeChart'" [yAxisPlot]="themearray">
              </app-bubble-chart>
            </div>
            <div class="col-12 nodata text-danger mt-5 mb-5" *ngIf="!showthemedata">
              {{'infotab.nodata' | translate}}
            </div>
          </div>
        </div>
  
      </div>
    </div>

    <!-- </div> -->
    <!-- </div> -->

    <!-- <div class="tab-content py-2" style="min-height: auto;" *ngIf="activesidetab == 'reportDownload'">
          <div role="tabpanel" class="tab-pane fade active show" id="pending">
            <div class="card mb-2">
              <a href="javascript:void(0)" class="downloadreport pt-2" (click)="downloadPdf('Round 1 report')">
                Round 1 report
              </a>
              <a href="javascript:void(0)" class="downloadreport pb-2" (click)="downloadPdf('Round 2 report')">
                Round 2 report
              </a>
            </div>
          </div>
        </div> -->

    <!-- </div>
    </div> -->

  </div>
</div>




<app-footer></app-footer>
